import { render, staticRenderFns } from "./CursosList.vue?vue&type=template&id=1d64108e&scoped=true"
import script from "./CursosList.vue?vue&type=script&lang=js"
export * from "./CursosList.vue?vue&type=script&lang=js"
import style0 from "./CursosList.vue?vue&type=style&index=0&id=1d64108e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d64108e",
  null
  
)

export default component.exports